/* Oh'G Theme - Direction A: Sticker Maximalist */

document.addEventListener('DOMContentLoaded', () => {
  console.log('Oh\'G theme loaded');

  // Initialize theme features
  initializeCarousels();
  initializeMobileMenu();
  initializeSmoothScroll();
  initializeAccessibility();
});

/**
 * Initialize carousel functionality
 */
function initializeCarousels() {
  const carousel = document.getElementById('carousel');
  if (carousel) {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        carousel.scrollBy({ left: -300, behavior: 'smooth' });
      } else if (e.key === 'ArrowRight') {
        carousel.scrollBy({ left: 300, behavior: 'smooth' });
      }
    });
  }

  document.querySelectorAll('[data-carousel-rail]').forEach(rail => {
    const parent = rail.parentElement;
    const leftBtn = parent?.querySelector('.carousel-btn-left');
    const rightBtn = parent?.querySelector('.carousel-btn-right');

    if (leftBtn && rightBtn) {
      leftBtn.addEventListener('click', () => {
        rail.scrollBy({ left: -300, behavior: 'smooth' });
      });

      rightBtn.addEventListener('click', () => {
        rail.scrollBy({ left: 300, behavior: 'smooth' });
      });
    }
  });
}

/**
 * Initialize mobile menu toggle
 */
function initializeMobileMenu() {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('active');
      menuToggle.setAttribute('aria-expanded',
        menuToggle.getAttribute('aria-expanded') === 'false' ? 'true' : 'false'
      );
    });

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
      if (!menuToggle.contains(e.target) && !mobileMenu.contains(e.target)) {
        mobileMenu.classList.remove('active');
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
}

/**
 * Initialize smooth scroll behavior
 */
function initializeSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;

      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
}

/**
 * Initialize accessibility features
 */
function initializeAccessibility() {
  // Trap focus in modals
  const modals = document.querySelectorAll('[role="dialog"]');
  modals.forEach(modal => {
    modal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        modal.close?.();
      }
    });
  });

  // Skip to main content link
  const skipLink = document.querySelector('[href="#main-content"]');
  if (skipLink) {
    skipLink.addEventListener('click', () => {
      const main = document.querySelector('#main-content');
      if (main) main.focus();
    });
  }
}

/**
 * Utility: Add/remove classes with animation
 */
window.animateElement = function(element, className, duration = 300) {
  if (!element) return;
  element.classList.add(className);
  setTimeout(() => {
    element.classList.remove(className);
  }, duration);
};

/**
 * Utility: Check if element is in viewport
 */
window.isInViewport = function(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.bottom >= 0
  );
};

/**
 * Utility: Debounce function for performance
 */
window.debounce = function(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
